import { ChapterType } from '@fsp/types';
import {
  AccountTreeTwoTone,
  FolderTwoTone,
  ListAltTwoTone,
  SecurityTwoTone,
  ThumbUpAltTwoTone,
  WarningTwoTone,
} from '@mui/icons-material';
import { SxProps, Theme } from '@mui/material';
import React from 'react';

interface ChapterIconProps {
  type?: ChapterType | null;
  sx?: SxProps<Theme>;
}

export const ChapterIcon: React.FC<ChapterIconProps> = ({ type, sx }) => {
  switch (type) {
    case 'flow':
      return <AccountTreeTwoTone sx={sx} />;
    case 'process':
      return <ListAltTwoTone sx={sx} />;
    case 'ccp':
      return <SecurityTwoTone sx={sx} />;
    case 'hazard':
      return <WarningTwoTone sx={sx} />;
    case 'correctiveAction':
      return <ThumbUpAltTwoTone sx={sx} />;
    case 'standard':
    default:
      return <FolderTwoTone sx={sx} />;
  }
};

export default ChapterIcon;
